import { IRouteDetails, IService } from 'src/app/models';
import { IPagination, IServicesState } from '../states';
import { ExpeditionCreationCriteria, ExpeditionType, RouteVisibility, TicketingType, DirectionsOrigin } from 'src/app/models/enums';

export const initialServicesState: IServicesState = {
  value: [] as IService[],
  isFetchingServices: false,
  pagination: {} as IPagination,
};

export function initialRouteCreate(): IRouteDetails {
  return {
    name: '',
    serviceId: undefined,
    town: undefined,
    managerClient: undefined,
    additionalClients: [],
    stops: [],
    apps: [],
    relatedServices: [],
    expeditionType: ExpeditionType[''],
    maxTime: undefined,
    centerBookingsInTime: false,
    bookOnReadyWithoutTrip: false,
    realTimeBookings: false,
    lastMinuteBookings: false,
    visibility: RouteVisibility.Public,
    terrain: undefined,
    outline: undefined,
    sms: false,
    push: true,
    email: true,
    publishingSites: [],
    criteria: ExpeditionCreationCriteria.None,
    showBusPosition: false,
    informative: false,
    maxPathTime: 0,
    minPathTime: 0,
    dynamicEndStop: false,
    dynamicStartStop: false,
    showUserDataToDriver: false,
    cancelBookingsOnReady: false,
    maxVariationTime: 0,
    maxVariability: 0,
    maxMergeDistance: 0,
    returnAfterEventEndMinutes: null,
    showOnlyOptimalRoutes: false,
    notifyNewTrips: false,
    singleStopBookings: false,
    avoidCriteriasValidation: false,
    ticketingType: TicketingType.None,
    fare: undefined,
    showRoute: false,
    saeIntegration: undefined,
    saeActions: [],
    goBack: false,
    active: true,
    directionsOrigin: DirectionsOrigin.None,
  };
}
